import React from 'react';

import useTranslation from '../../hooks/use_translation';
import ella from '../../images/how_it_works/ella.jpg';
import simon from '../../images/how_it_works/simon.webp';
import SectionHeader from '../framework/sections/section-header';
import VideoPlaylist from '../framework/video_playlist';

const Why = () => {
	const { t } = useTranslation('component_why');

	return (
		<div className="container">
			<div className="row align-items-center justify-content-between">
				<div className="col-md-6">
					<div className="mb-3 mb-md-0">
						<VideoPlaylist
							audio
							className="shadow shadow-lg"
							playlist={[
								{
									avatarSrc: simon,
									avatarSubtitle: t('t9'),
									avatarTitle: 'Simon Mäntylä',
									mp4: 'https://cdn.testmottagningen.se/assets/2025/03/19/simon-video-how-it-works-695.mp4',

									title: 'Simon Mäntylä lämnar blodprov inför hälsokontroll',
									webm: 'https://cdn.testmottagningen.se/assets/2025/03/19/video-how-it-works-simon-webm-696.webm',
								},
								/*
								{
									avatarSrc: ella,
									avatarSubtitle: t('t9'),
									avatarTitle: 'Ella Wunger',
									mp4: 'https://cdn.testmottagningen.se/assets/2024/07/31/video-how-it-works-ella-mp4-498.mp4',
									subtitles: {
										en: 'https://cdn.testmottagningen.se/assets/2024/07/31/subtitle-how-it-works-ella-en-500.vtt',
										sv: 'https://cdn.testmottagningen.se/assets/2024/07/31/subtitle-how-it-works-ella-sv-499.vtt',
									},
									title: 'Ella Wunger lämnar blodprov inför hälsokontroll',
									webm: 'https://cdn.testmottagningen.se/assets/2024/08/01/video-how-it-works-ella-mp4-503.webm',
								},
								*/
							]}
							poster="https://cdn.testmottagningen.se/assets/2024/06/18/video-poster-image-simon-2-490.jpg"
							progressBar
							rounded_corners
							variant="9:16"
						/>
					</div>
				</div>
				<div className="col-md-5">
					<div className="row">
						<SectionHeader
							headingType="p"
							hideButton={true}
							size="lg"
							subHeadingType="h3"
							subTitle={t('t1')}
							title={t('t2')}
						/>
					</div>

					<div className="mb-3">
						<h4 className="title-small">{t('t3')}</h4>
						<p className="small text-muted">{t('t4')}</p>
					</div>
					<div className="mb-3">
						<h4 className="title-small">{t('t5')}</h4>
						<p className="small text-muted">{t('t6')}</p>
					</div>
					<div className="mb-3">
						<h4 className="title-small">{t('t7')}</h4>
						<p className="small text-muted">{t('t8')}</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Why;
